import { action, observable, computed } from 'mobx';
import { IVideoToutYoutubeProps } from '~exported/video-tout-youtube/VideoToutYoutube';
import { ViewController } from '@estee/elc-service';
import { INodeContent } from '~domain/entities/Node';

export class VideoToutYoutubeViewController extends ViewController {
    @observable public _content: Map<number, INodeContent>;

    constructor() {
        super();
        this._content = new Map();
    }

    @action
    public initialize = async (props: IVideoToutYoutubeProps) => {
        this.isLoading = true;
        const { nid, layout, data } = props.config;
        this.content = {
            nid,
            layout,
            data
        };

        this.isLoading = false;
    };

    @computed
    get data() {
        return {
            content: this._content
        };
    }

    public getContent(nid: number) {
        return this._content.get(nid);
    }

    public set content(input: INodeContent) {
        const { nid } = input;
        this._content.set(nid, { ...input });
    }
}
